import { injectable } from 'inversify';

import { BlotterServiceAbstract } from './blotter.service';
import { EBlotterTab } from '../../enums';
import { getBlotterForwardColumnDefs } from '.';
import { IOrderReport, Predicate } from '../../interfaces';

@injectable()
export class BlotterForwardService extends BlotterServiceAbstract {
    filter: Predicate<IOrderReport> = (order: IOrderReport) => order.orderType !== 'spot';
    columnDefinitions = getBlotterForwardColumnDefs;
    type = 'forward' as EBlotterTab;
    isRowActionsEnabled = false;
}
